interface PageHeadlineProps {
    children: React.ReactNode;
}

const PageHeader = (props: PageHeadlineProps) => {
    return <header className={'flex flex-row gap-2 justify-between items-center mb-5'}>{props.children}</header>;
};

export default PageHeader;
